import { AdTabProps } from "./tab";

enum AdTabsEnum {
  RGCams="RGCams",
  LiveSex="LiveSex",
}

type AdTabsProps = {
  [name in AdTabsEnum]: AdTabProps;
}

export const tabs: AdTabsProps = {
  [AdTabsEnum.RGCams]: {
    link: "https://rgcams.com/landing/click/?AFNO=1-1",
  },
  [AdTabsEnum.LiveSex]: {
    link: "http://bit.ly/42ukupf",
  },
};
